export enum GuestbookForm {
  Guest = 'guest',
  LoyaltyCard = 'loyaltyCard',
  LoyaltyCards = 'loyaltyCards',
}
